<template>
  <div class="limiter-content pa-3 pa-lg-0">
    <div class="padding-block"></div>

    <page-title :eyebrow="$root.user && Number($root.user.type) === 2 ? 'ÁREA DO PROCURADOR' : 'ÁREA DO CREDOR'" :icon="$root.user && Number($root.user.type) === 2 ? 'mdi-briefcase-account-outline' : 'mdi-account-circle-outline'" title="Solicitar" highlight="credenciamento" />

	    <v-row>
	      <v-col>
          <span v-if="selectedGeneralMeeting">
	          Você está {{ regularizeId ? 'regularizando' : 'realizando' }} o credenciamento para a Assembleia <strong>{{ dataset.generalMeeting.name }}</strong>.
	        </span>
          <span v-else>
            Selecione o caso e a Assembleia Geral de Credores para iniciar o credenciamento.
          </span>
	      </v-col>
	    </v-row>

      <v-alert v-if="selectedGeneralMeeting && dataset.generalMeeting.accreditation_availability"
        :type="dataset.generalMeeting.accreditation_availability.is_open ? 'success' : 'warning'"
        text dense class="mt-4">
        {{ dataset.generalMeeting.accreditation_availability.message }}
      </v-alert>

    <v-form v-if='user' ref="form" v-model="valid" class='mt-10'
      :class="{ 'accreditation-form-disabled': selectedGeneralMeeting && dataset.generalMeeting.accreditation_availability && !dataset.generalMeeting.accreditation_availability.is_open && !regularizeId }">
      <procurator-creditor-selector
        v-model="selectedCreditorId"
        :client-id="selectedClient"
        :require-client="true"
        :disabled="bulkMode"
        @selected="onCreditorSelected"
        @loaded="onCreditorsLoaded">
      </procurator-creditor-selector>

      <!-- Credenciamento em lote: todos os credores com associacao aprovada no caso -->
      <v-card v-if="isProcurator && bulkCreditors.length > 1 && !regularizeId" outlined class="pa-3 mb-4">
        <v-switch v-model="bulkMode" dense hide-details class="mt-0"
          :label="`Credenciar todos os credores deste caso de uma vez (${bulkCreditors.length} credores aptos)`"
          @change="onBulkModeChange"></v-switch>
        <div v-if="bulkMode && bulkCreditorsWithoutAgcPower.length" class="text-caption warning--text mt-2">
          {{ bulkCreditorsWithoutAgcPower.length }} credor(es) ficam fora do lote porque a procuração da associação não tem o poder de
          Participação em Assembleia de Credores: {{ bulkCreditorsWithoutAgcPower.map((item) => item.creditor_name).join(', ') }}.
        </div>
        <div v-if="bulkMode" class="text-caption grey--text text--darken-1 mt-2">
          Será criado um credenciamento por credor, na assembleia escolhida, reaproveitando o documento do credor e a procuração de cada associação.
          Credores já credenciados nesta assembleia são pulados.
        </div>
      </v-card>

      <template>
        <v-stepper v-model="e1" vertical>
          <v-stepper-step :complete="e1 > 1" step="1">
            <v-row no-gutters justify='center' align='center'>
              <v-col cols='11'>
                <h4>Participação</h4>
                <small>Selecione a participação</small>
              </v-col>

              <v-col cols='1'>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small :color="e1 === 1 ? 'primary' : ''" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Informações sobre a participacao</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-stepper-step>

	          <v-stepper-content step="1">
	            <v-form ref="form" class='px-3' v-model="valid">
                <v-row v-if="!routeGeneralMeetingId">
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="selectedClient"
                      :items="clients"
                      :loading="loadingClients"
                      item-text="name"
                      item-value="id"
                      label="Caso"
                      outlined
                      dense
                      :rules="[$rules.required]"
                      @change="onClientChange">
                    </v-select>
                  </v-col>

                  <v-col cols="12" md="6">
	                    <v-select
	                      v-model="selectedGeneralMeeting"
	                      :items="generalMeetings"
	                      :loading="loadingGeneralMeetings"
	                      item-text="label"
	                      item-value="id"
	                      label="Assembleia Geral de Credores"
                      outlined
                      dense
                      :disabled="!selectedClient"
                      :rules="[$rules.required]"
                      @change="onGeneralMeetingChange">
                    </v-select>
                  </v-col>
                </v-row>

	              <v-row>
	                <v-col cols="12">
	                  <v-radio-group v-model="participationType">
                    <v-radio label="Participar em nome próprio" value="own"></v-radio>
                    <v-radio label="Participar por representação (advogado)" value="representation"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <!-- Sem credito com direito a voto no caso: participa como ouvinte e justifica o interesse -->
              <v-row v-if="listenerParticipation">
                <v-col cols="12">
                  <v-alert type="info" text dense>
                    Não encontramos crédito com direito a voto neste caso. A participação será como <strong>ouvinte</strong>:
                    é possível acompanhar a assembleia, sem votar e sem entrar na lista de presença.
                  </v-alert>
                  <v-textarea v-model="interestJustification" outlined dense auto-grow rows="3" counter="5000" maxlength="5000"
                    label="Justificativa de interesse" placeholder="Explique por que deseja acompanhar a assembleia"
                    :rules="[$rules.required]"></v-textarea>
                </v-col>
              </v-row>

	              <v-btn @click="e1 = 2" :disabled="!canContinueParticipationStep" class="primary">Continuar</v-btn>
            </v-form>
          </v-stepper-content>

          <v-stepper-step :complete="e1 > 2" step="2">
            <v-row no-gutters justify='center' align='center'>
              <v-col cols='11'>
                <h4>Informações</h4>
                <small>Selecione as informações abaixo</small>
              </v-col>

              <v-col cols='1'>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small :color="e1 === 2 ? 'primary' : ''" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Informações sobre a participacao</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-row no-gutters>
              <v-col>
                <v-alert v-if="reuseAssociationDocuments" dense text type="success" class="mt-1 mb-2">
                  <strong>Documentos reaproveitados da associação aprovada.</strong>
                  O documento de identificação do credor e a procuração já enviados na associação serão usados neste credenciamento.
                  Nada precisa ser anexado de novo.
                </v-alert>
                <v-text-field v-else prepend-icon="mdi-paperclip" readonly outlined class='mt-1' dense
                  :value="files.idCredor ? files.idCredor.name : ''" label="Documento de identificação do credor"
                  @click.prevent="openDocumentModal('idCredor', 1)" :rules="[$rules.required]">
                </v-text-field>
              </v-col>
              <v-col sm="1"></v-col>
	              <v-col>
                <v-text-field v-if="participationType === 'representation' && !reuseAssociationDocuments" readonly prepend-icon="mdi-paperclip" outlined
                  class='mt-1' dense :disabled="useAssociationProcuration"
	                  :value="useAssociationProcuration ? 'Usar procuração da associação aprovada' : (files.procuracao ? files.procuracao.name : '')"
	                  label="Procuração"
	                  @click.prevent="!useAssociationProcuration && openDocumentModal('procuracao', 2)"
	                  :rules="useAssociationProcuration ? [] : [$rules.required]">
	                </v-text-field>
	              </v-col>
	            </v-row>
            <v-alert v-if="associationLacksAgcPower && participationType === 'representation'" dense text type="warning" class="mt-1 mb-2">
              A procuração da associação com este credor <strong>não tem o poder de Participação em Assembleia de Credores</strong>.
              Anexe uma procuração específica para este credenciamento.
            </v-alert>
            <v-row no-gutters v-if="isProcurator && participationType === 'representation' && !reuseAssociationDocuments && !associationLacksAgcPower">
              <v-col>
                <v-checkbox
                  v-model="useAssociationProcuration"
	                  dense
	                  hide-details
	                  label="Usar a mesma procuração da associação aprovada"
	                  @change="onUseAssociationProcurationChange"
	                ></v-checkbox>
	              </v-col>
	            </v-row>

            <v-row no-gutters>
              <v-col>
                <v-text-field v-if="participationType === 'representation'" prepend-icon="" outlined class='mt-1' dense
                  v-model="dataset.data.procurator_name" label="Nome do procurador" :rules="[$rules.required]">
                </v-text-field>
              </v-col>
              <v-col sm="1"></v-col>
	              <v-col>
	                <v-text-field v-if="participationType === 'representation'" prepend-icon="" outlined class='mt-1' dense
	                  v-model="dataset.data.procurator_registration" label="OAB (se advogado)"
	                  :rules="dataset.data.procurator_oab_state ? [$rules.required] : []">
	                </v-text-field>
	              </v-col>
	            </v-row>

	            <v-row no-gutters>
	              <v-col>
	                <v-text-field v-if="participationType === 'representation'" prepend-icon="" outlined class='mt-1' dense
	                  v-model="dataset.data.procurator_email" label="E-mail do procurador"
	                  :rules="[$rules.required, $rules.email]">
	                </v-text-field>
	              </v-col>
	              <v-col sm="1"></v-col>
	              <v-col>
	                <v-select v-if="participationType === 'representation'" outlined class='mt-1' dense
	                  v-model="dataset.data.procurator_oab_state" :items="statesList" item-text="name" item-value="name"
	                  label="UF da OAB" :rules="dataset.data.procurator_registration ? [$rules.required] : []">
	                </v-select>
	              </v-col>
	            </v-row>

            <!-- Poderes da procuracao anexada (mesma lista da associacao) -->
            <div v-if="participationType === 'representation' && !reuseAssociationDocuments && !useAssociationProcuration" class="mt-2 mb-4">
              <div class="font-weight-bold">Poderes especiais da procuração anexada</div>
              <div class="text-caption text--secondary mb-1">
                Marque os poderes que constam na procuração.
                <a class="ml-2" @click.prevent="setAllPowers(true)">[Marcar todos]</a>
                <a class="ml-1" @click.prevent="setAllPowers(false)">[Desmarcar todos]</a>
              </div>
              <v-row dense>
                <v-col v-for="power in procurationPowers" :key="power.id" cols="12" md="6">
                  <v-checkbox dense hide-details class="mt-0" :value="power.id" v-model="procurationPowersSelected">
                    <template #label>
                      <span :class="{ 'font-weight-bold': power.highlight }">{{ power.name }}</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <div v-if="!procurationPowersSelected.includes(AGC_POWER)" class="text-caption warning--text mt-2">
                Atenção: a procuração anexada não indica o poder de Participação em Assembleia de Credores.
              </div>
            </div>

            <v-btn @click="e1 = 3" :disabled="!valid" class="primary">Continuar</v-btn>
            <v-btn text @click="e1 = 1; clearFormFields()" class="ml-3">Voltar</v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="e1 > 3" step="3">
            <v-row no-gutters justify='center' align='center'>
              <v-col cols='11'>
                <h4>Confirmação</h4>
                <small>Revise e confirme</small>
              </v-col>

              <v-col cols='1'>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small :color="e1 === 3 ? 'primary' : ''" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Faça a revisão e envie os documentos</span>
                </v-tooltip>
              </v-col>
            </v-row>

          </v-stepper-step>

          <v-stepper-content step="3">
            <v-row>
              <v-col cols="12">
                <div class='py-3'>
                  <p v-if="participationType === 'own'">
                    Você está participando em nome próprio e enviou o documento: <br> {{ files.idCredor ?
                      files.idCredor.name : 'Nenhum documento enviado' }}.
                  </p>
                  <p v-else>
                    Você está participando por representação e enviou os seguintes documentos:
                    <br>
                    <br>
                    <strong>Documento de Identificação: </strong>
                    {{ files.idCredor ? files.idCredor.name : 'Nenhum' }}
                    <br>
	                    <strong>Procuração: </strong>
	                    {{ useAssociationProcuration ? 'Procuração da associação aprovada' : (files.procuracao ? files.procuracao.name : 'Nenhum') }}
                    <br>
                    <template v-if="!reuseAssociationDocuments && !useAssociationProcuration">
                      <strong>Poderes da procuração: </strong>
                      {{ procurationPowersSelected.length ? procurationPowersSelected.map(powerLabel).join(', ') : 'Não informados' }}
                      <br>
                    </template>
                    <strong>Procurador:</strong>
                    {{ dataset.data.procurator_name }}
                    <br>
                    <strong>E-mail do procurador:</strong>
                    {{ dataset.data.procurator_email }}
                    <br>
	                    <strong>OAB do procurador:</strong>
	                    {{ dataset.data.procurator_registration ? `${dataset.data.procurator_registration}/${dataset.data.procurator_oab_state}` : 'Não informada' }}.
                  </p>
                </div>
                <v-btn @click="save" :disabled="!valid || dataset.loading" :loading="dataset.loading" class="primary">
                  {{ regularizeId ? 'Regularizar e Enviar' : 'Confirmar e Enviar' }}
                </v-btn>
                <!-- <v-btn @click="cancelSubmission" text class="ml-3">Cancelar</v-btn> -->
                <v-btn text @click="e1 = 2; clearFormFields()" class="ml-3">Voltar</v-btn>

              </v-col>
            </v-row>
          </v-stepper-content>

        </v-stepper>
      </template>

    </v-form>

    <v-dialog v-model="showDocumentModal" max-width="800px">
      <v-card>
        <v-card-title>Escolha um Documento</v-card-title>
        <v-card-text>
          <!-- <v-btn class='mb-3' @click="showAddDocumentModal = true" color="primary">
            Novo documento
          </v-btn> -->
	          <v-btn class='mb-3' @click="openAddModalDocument(currentDocTypeId)" color="primary"
              :disabled="loadingDocuments || savingDocument">
	            Novo documento
	          </v-btn>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>Selecionar da Central de Documentos</v-expansion-panel-header>
	              <v-expansion-panel-content>
	                <v-progress-linear v-if="loadingDocuments" indeterminate color="primary"></v-progress-linear>
                  <div v-if="loadingDocuments" class="text-center grey--text py-4">
                    Carregando documentos...
                  </div>
		                <v-list dense v-else-if="centralDocuments.length">
                  <v-list-item v-for="(doc, index) in centralDocuments" :key="index">
                    <v-list-item-action>
                      <v-checkbox v-model="doc.isSelected" :disabled="!doc.isSelected && isAnyDocumentSelected">
                      </v-checkbox>

                    </v-list-item-action>
                    <v-list-item-content>{{ doc.name }}</v-list-item-content>
                    <v-list-item-content>{{ doc.type }}</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-card-actions class='pa-0 mt-4'>
	            <v-btn color="primary" @click="closeModal" :disabled="loadingDocuments">Fechar</v-btn>
	            <v-btn color="secondary" @click="confirmSelection" :disabled="loadingDocuments">Confirmar</v-btn>
          </v-card-actions>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddDocumentModal" max-width="800px">
      <v-card>
        <v-card-title>Adicione um novo documento</v-card-title>

        <v-form ref="form" v-model="valid">
          <v-card-text class='mt-1'>
            <v-text-field outlined dense required :rules="[$rules.required]" v-model="newDocument.name"
              label="Nome"></v-text-field>

            <!-- <v-select :items="dataset.itemTypes" :rules="[$rules.required]" item-text="name" item-value="id"
              v-model="newDocument.type" label="Tipo" outlined dense required></v-select> -->

            <v-text-field outlined dense readonly :value="getDocTypeName(currentDocTypeId)"
              label="Tipo de Documento"></v-text-field>


            <v-file-input outlined dense required prepend-icon="" :rules="[$rules.required]" v-model='newDocument.file'
              label="Upload do Documento">
            </v-file-input>

          </v-card-text>

          <v-col cols='12' sm='3'>
	            <v-btn @click="saveNewDocument" color="success" block :loading="savingDocument" :disabled="savingDocument">
	              Enviar
	            </v-btn>
          </v-col>

        </v-form>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { eventHub } from '@/main';

import axios from 'axios';
import itemTypes from "@/common/data/item-types.data.js";
import ProcuratorCreditorSelector from '@/components/ProcuratorCreditorSelector.vue';
import statesList from "@/common/data/states-list.data";
import procurationPowers, { AGC_POWER } from "@/common/data/procuration-powers.data";


export default {
  name: 'AccreditationPage',

  components: {
    ProcuratorCreditorSelector,
  },

  data() {
    return {
		      user: null,
	        statesList,
	        procurationPowers,
	        AGC_POWER,
	        // Poderes marcados para a procuracao anexada neste credenciamento.
	        procurationPowersSelected: [],
	        selectedCreditorId: null,
	        useAssociationProcuration: false,
        selectedAssociation: null,
        procuratorCreditors: [],
        bulkMode: false,
        routeGeneralMeetingId: null,
        regularizeId: null,
        selectedClient: null,
        selectedGeneralMeeting: null,
        // Previa da participacao (1 credor, 2 ouvinte) e justificativa do ouvinte.
        participationPreview: null,
        interestJustification: '',
        clients: [],
        generalMeetings: [],
        openGeneralMeetings: [],
        loadingClients: false,
        loadingGeneralMeetings: false,
	      currentDocTypeId: null,
      valid: true,
      panel: [0],
	      savingDocument: false,
        loadingDocuments: false,
      e1: 1,
      participationType: '',
      clientId: null,
      meetingInfo: null,
      files: {
        idCredor: null,
        procuracao: null
      },
      newDocument: {},
      showDocumentModal: false,
      showAddDocumentModal: false,
      newFile: null,
      centralDocuments: [],
      currentDocType: null,
      dataset: {
        itemTypes: itemTypes,
        loading: false,
        generalMeeting: {},
        data: {}
      },
    };
  },

	  created() {
      this.user = this.$root.user;
      this.routeGeneralMeetingId = this.$route.query.id || null;
      this.regularizeId = this.$route.query.regularize_id || null;
      this.selectedCreditorId = this.$route.query.creditor_user_id || null;
	
	    if (this.routeGeneralMeetingId) {
        this.selectedGeneralMeeting = this.routeGeneralMeetingId;
        this.loadGeneralMeeting(this.routeGeneralMeetingId);
      } else {
        this.loadClients();
      }
	
	  },

  computed: {
	    // Credores do caso com associacao aprovada (base do credenciamento em lote).
    bulkCreditors() {
      // Em lote so entram os credores cuja procuracao da associacao cobre a assembleia.
      return (this.procuratorCreditors || []).filter((item) => Number(item.status) === 1 && item.creditor_user_id && (item.procuration_powers || []).includes(AGC_POWER));
    },
    // Procurador com associacao aprovada nao precisa reenviar documento do credor nem procuracao.
    reuseAssociationDocuments() {
      if (!this.isProcurator || this.participationType !== 'representation' || this.regularizeId) return false;
      if (this.bulkMode) return true;
      return this.associationHasAgcPower;
    },
    // Associacao aprovada cuja procuracao tem o poder de participacao em assembleia.
    associationHasAgcPower() {
      const association = this.selectedAssociation;
      if (!association || Number(association.status) !== 1) return false;
      return (association.procuration_powers || []).includes(AGC_POWER);
    },
    // Associacao aprovada, mas a procuracao nao cobre assembleia: precisa de procuracao nova.
    associationLacksAgcPower() {
      return !!(this.isProcurator && this.selectedAssociation && Number(this.selectedAssociation.status) === 1 && !this.associationHasAgcPower);
    },
    bulkCreditorsWithoutAgcPower() {
      return (this.procuratorCreditors || []).filter((item) => Number(item.status) === 1 && item.creditor_user_id && !(item.procuration_powers || []).includes(AGC_POWER));
    },
    isProcurator() {
	      return !!this.user && Number(this.user.type) === 2;
	    },

    idCredorName() {
      const doc = this.centralDocuments.find(d => d.id === this.files.idCredor);
      return doc ? doc.type : '';
    },

    procuracaoName() {
      const doc = this.centralDocuments.find(d => d.id === this.files.procuracao);
      return doc ? doc.name : '';
    },

	    isAnyDocumentSelected() {
	      return this.centralDocuments.some(doc => doc.isSelected);
	    },

      listenerParticipation() {
        return !this.bulkMode && Number(this.participationPreview) === 2;
      },

      canContinueParticipationStep() {
        if (this.listenerParticipation && !String(this.interestJustification || '').trim()) return false;
        return (!this.isProcurator || !!this.selectedCreditorId || this.bulkMode) && !!this.selectedGeneralMeeting && !!this.participationType;
      }
	  },


	  watch: {
      selectedGeneralMeeting() { this.loadParticipationPreview(); },
      selectedCreditorId() { this.loadParticipationPreview(); },
	  },

	  methods: {
      // Credor ou ouvinte para a AGC escolhida (no caso do procurador, para o credor representado).
      async loadParticipationPreview() {
        this.participationPreview = null;
        if (!this.selectedGeneralMeeting || this.bulkMode || (this.isProcurator && !this.selectedCreditorId)) return;
        try {
          const params = { general_meeting_id: this.selectedGeneralMeeting };
          if (this.selectedCreditorId) params.creditor_user_id = this.selectedCreditorId;
          const response = await axios.get('/api/accreditations/participation', { params });
          this.participationPreview = response.data.content ? response.data.content.participation_type : null;
        } catch (error) {
          this.participationPreview = null;
        }
      },

    onCreditorSelected(item) {
      this.selectedAssociation = item || null;
      this.prefillProcuratorFields();
    },
    onCreditorsLoaded(items) {
      this.procuratorCreditors = Array.isArray(items) ? items : [];
      if (this.bulkMode && this.bulkCreditors.length < 2) this.bulkMode = false;
    },
    onBulkModeChange(value) {
      if (value) {
        this.selectedCreditorId = null;
        this.selectedAssociation = null;
        this.participationType = 'representation';
        this.prefillProcuratorFields();
      }
    },
    // Procurador logado: os dados do procurador sao os dele.
    setAllPowers(checked) {
      this.procurationPowersSelected = checked ? this.procurationPowers.map((power) => power.id) : [];
    },
    powerLabel(id) {
      const found = this.procurationPowers.find((item) => item.id === id);
      return found ? found.name : id;
    },
    prefillProcuratorFields() {
      if (!this.isProcurator || !this.user) return;
      const data = this.dataset.data;
      if (!data.procurator_name) data.procurator_name = this.user.name || '';
      if (!data.procurator_email) data.procurator_email = this.user.email || '';
      if (!data.procurator_registration && this.user.oab) data.procurator_registration = this.user.oab;
      if (!data.procurator_oab_state && this.user.oab_state) data.procurator_oab_state = this.user.oab_state;
    },
	    onUseAssociationProcurationChange(value) {
	      if (value) this.files.procuracao = null;
	    },

	    openAddModalDocument(docTypeId) {
      event.preventDefault();
      this.currentDocTypeId = docTypeId;
      this.currentDocTypeName = this.getDocTypeName(docTypeId);
      this.showAddDocumentModal = true;
    },

    getDocTypeName(docTypeId) {
      let docType = this.dataset.itemTypes.find(type => type.id === docTypeId);
      return docType ? docType.name : 'Tipo Desconhecido';
    },

      async loadClients() {
        this.loadingClients = true;

        try {
          const response = await axios.get('/api/general-meetings', {
            params: {
              start: 0,
              limit: 100000,
              search: { status: 0 }
            }
          });

          this.openGeneralMeetings = (response.data.content || [])
            .filter(item =>
              item.status === 0 &&
              this.$moment(item.date).isAfter() &&
              this.isAccreditationOpen(item) &&
              item.client &&
              (item.client.portal_accreditations_enabled === undefined
                ? (item.client.creditor_portal_enabled === undefined || Number(item.client.creditor_portal_enabled) !== 0)
                : Number(item.client.portal_accreditations_enabled) !== 0)
            )
            .map(item => ({
              ...item,
              label: `${this.$moment(item.date).format('DD/MM/YYYY HH:mm')} BRT - ${item.name}`
            }));

          const clientsById = this.openGeneralMeetings.reduce((acc, item) => {
            if (item.client && !acc[item.client.id]) {
              acc[item.client.id] = item.client;
            }

            return acc;
          }, {});

          this.clients = Object.values(clientsById)
            .sort((a, b) => a.name.localeCompare(b.name));
        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 3000 });
        } finally {
          this.loadingClients = false;
        }
      },

      isAccreditationOpen(item) {
        if (!item || Number(item.status) !== 0) return false;
        if (item.accreditation_enabled === false || Number(item.accreditation_enabled) === 0) return false;
        if (item.accreditation_closed_at) return false;
        if (item.accreditation_starts_at && this.$moment(item.accreditation_starts_at).isAfter()) return false;
        if (item.accreditation_ends_at && !this.$moment(item.accreditation_ends_at).isAfter()) return false;
        return true;
      },

      async onClientChange() {
        this.selectedGeneralMeeting = null;
        this.dataset.generalMeeting = {};
        this.generalMeetings = [];

        if (!this.selectedClient) return;

        await this.loadGeneralMeetingsByClient(this.selectedClient);
      },

      async loadGeneralMeetingsByClient(clientId) {
        this.loadingGeneralMeetings = true;

        try {
          this.generalMeetings = this.openGeneralMeetings
            .filter(item => Number(item.client_id) === Number(clientId));
        } catch (error) {
          this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 3000 });
        } finally {
          this.loadingGeneralMeetings = false;
        }
      },

      async onGeneralMeetingChange() {
        if (!this.selectedGeneralMeeting) return;

        await this.loadGeneralMeeting(this.selectedGeneralMeeting);
      },

	    async loadGeneralMeeting(generalMeetingId = this.selectedGeneralMeeting) {
        if (!generalMeetingId) return;

	      try {

        const timezone = 'America/Sao_Paulo';

        //const response = await axios.get(`/api/general-meetings/${this.$route.query.id}`);

	        const response = await axios.get(`/api/general-meetings/${generalMeetingId}`, {
          headers: {
            'Timezone': timezone
          }
        });

	        this.dataset.generalMeeting = response.data.content;
          this.selectedGeneralMeeting = response.data.content.id;
          this.selectedClient = response.data.content.client_id;

      } catch (error) {
        console.error('Erro ao obter informações do meeting', error);
      }
    },

    onFileChange(fileType, event) {
      if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
        console.error('Nenhum arquivo foi selecionado ou houve um problema no evento de seleção de arquivo');
        return;
      }

      this.files[fileType] = event.target.files[0];
    },

    async submitForm() {
      if (this.e1 !== 3) return;

      if (!this.$refs.form.validate()) return;

      // if (idCredorFile) {

      //   await this.$dialog.notify.success('Documentos enviados com sucesso!', {
      //     position: 'top-right',
      //     timeout: 5000
      //   });

      //   console.log('Documento de identificação do credor:', idCredorFile.name, idCredorFile);
      //   this.clearFormFields();
      // } else {
      //   console.log('Nenhum documento de identificação do credor selecionado');
      // }

      const payload = this.buildPayload()

      // if (this.participationType === 'representation' && procuracaoFile) {
      //   console.log('Procuração:', procuracaoFile.name, procuracaoFile);
      // } else if (this.participationType === 'representation') {
      //   console.log('Nenhum documento de procuração selecionado');
      // }
    },

	    async save() {
        if (this.dataset.loading) return;

	      if (this.e1 !== 3) return;

      if (!this.$refs.form.validate()) return;

      const proceedAction = await this.$dialog.confirm({
        text: this.regularizeId ? 'Deseja reenviar este credenciamento para análise?' : 'Deseja enviar o credenciamento?',
        title: this.regularizeId ? 'Regularizar credenciamento' : 'Finalizar',
        actions: {
          false: 'Cancelar',
          true: this.regularizeId ? 'Regularizar' : 'Concluir'
        }
      });

      if (!proceedAction) return;

        this.dataset.loading = true;

        await this.loadGeneralMeeting(this.selectedGeneralMeeting);
	      
      const payload = this.buildPayload();
      try {
        if (this.bulkMode && !this.regularizeId) {
          await this.submitBulk(payload);
          return;
        }
        if (this.regularizeId) {
          await axios.patch(`/api/accreditations/${this.regularizeId}/resubmit`, payload);
        } else {
          await axios.post('/api/accreditations', payload);
        }

        await this.$dialog.confirm({
          text: this.regularizeId
            ? 'Credenciamento regularizado com sucesso! Ele voltou para análise.'
            : 'Informações enviadas com sucesso! Você receberá um e-mail assim que o seu credenciamento for analisado.',
          title: 'Sucesso',
          actions: {
            true: 'OK'
          }
        });

        this.dataset.data = {};

	        this.$router.replace('/credenciamentos');

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        });
      } finally {
        this.dataset.loading = false;
      }
    },

	    buildPayload() {
	      const result = {
	        has_procurator: this.participationType == 'representation',
	        general_meeting_id: this.selectedGeneralMeeting,
	        files: this.reuseAssociationDocuments ? [] : [this.files.idCredor.id]
	      };
      if (this.reuseAssociationDocuments) {
        result.use_association_documents = true;
        result.use_association_procuration = true;
      }

      if (this.selectedCreditorId) result.creditor_user_id = this.selectedCreditorId;
      if (this.listenerParticipation) result.interest_justification = String(this.interestJustification || '').trim();

	      if (this.participationType == 'representation') {
	        result.procurator_email = this.dataset.data.procurator_email;
	        result.procurator_name = this.dataset.data.procurator_name;
	        result.procurator_registration = this.dataset.data.procurator_registration;
	        result.procurator_oab_state = this.dataset.data.procurator_oab_state;
	        if (!this.reuseAssociationDocuments) {
	          result.use_association_procuration = this.useAssociationProcuration;
	          if (!this.useAssociationProcuration) {
	            result.files.push(this.files.procuracao.id);
	            result.procuration_powers = [...this.procurationPowersSelected];
	          }
	        }
	      }

      return result;
    },

    // Credenciamento em lote: um pedido por credor com associacao aprovada.
    async submitBulk(basePayload) {
      const ok = [];
      const skipped = [];
      const failed = [];
      for (const creditor of this.bulkCreditors) {
        const payload = { ...basePayload, creditor_user_id: creditor.creditor_user_id, files: [] };
        try {
          await axios.post('/api/accreditations', payload);
          ok.push(creditor.creditor_name);
        } catch (error) {
          const message = this.$codes(error) || '';
          if (/já foi realizado/i.test(message)) skipped.push(creditor.creditor_name);
          else failed.push(`${creditor.creditor_name}: ${message}`);
        }
      }
      const lines = [`Credenciamentos enviados: ${ok.length}.`];
      if (skipped.length) lines.push(`Já credenciados (pulados): ${skipped.length}.`);
      if (failed.length) lines.push(`Com erro: ${failed.length}.<br>${failed.slice(0, 8).join('<br>')}`);
      await this.$dialog.confirm({
        title: failed.length ? 'Lote concluído com pendências' : 'Lote concluído',
        text: lines.join('<br>'),
        actions: { true: 'OK' },
      });
      this.dataset.data = {};
      this.dataset.loading = false;
      this.$router.replace('/credenciamentos');
    },

    cancelSubmission() {
      this.e1 = 1;
      this.clearFormFields();
    },

    clearFormFields() {
	      this.files.idCredor = null;
	      this.files.procuracao = null;
	      this.useAssociationProcuration = false;
	      this.procurationPowersSelected = [];

	      if (this.participationType === 'representation') {
	        this.dataset.data.procurator_name = '';
	        this.dataset.data.procurator_registration = '';
	        this.dataset.data.procurator_email = '';
	        this.dataset.data.procurator_oab_state = '';
	      }
    },

	    openDocumentModal(docType, docTypeId) {
        if (this.loadingDocuments || this.savingDocument) return;

	      this.currentDocType = docType;
	      this.currentDocTypeId = docTypeId;
        this.centralDocuments = [];
        this.showDocumentModal = true;
	      this.loadingDocuments = true;

	      this.getDocuments(docTypeId).finally(() => {
	        this.loadingDocuments = false;
	      });
	    },


    confirmSelection() {
      const selectedDoc = this.centralDocuments.find(doc => doc.isSelected);

      if (selectedDoc) {
        if (this.currentDocType === 'idCredor') {
          this.files.idCredor = selectedDoc;
        } else if (this.currentDocType === 'procuracao') {
          this.files.procuracao = selectedDoc;
        }
      }

      this.closeModal();
    },


    closeModal() {
      this.showDocumentModal = false;
      this.centralDocuments.forEach(doc => doc.isSelected = false);
    },


    closeAddModalDocument() {
      this.showAddDocumentModal = false;
    },

    async getDocuments(docTypeId) {
      try {
        const response = await axios.get(`/api/user-docs`, {
          params: { start: 0, limit: 1000, search: { "type": docTypeId } }
        });

        if (response.data && response.data.status && response.data.content) {

          this.centralDocuments = response.data.content.data.map(doc => {

            const docType = this.dataset.itemTypes.find(type => type.id === doc.type);

            return {
              isSelected: false,
              name: doc.name,
              type: docType ? docType.name : '',
              created_at: doc.created_at,
              file_url: doc.file_url,
              id: doc.id
            };
          }).sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
          });
        }


      } catch (error) {
        console.error("Erro ao obter documentos", error);
      }
    },

    async saveNewDocument() {
      if (!this.$refs.form.validate()) return;
      this.savingDocument = true;

      try {
        let formData = new FormData();

        formData.append('name', this.newDocument.name);
        formData.append('type', this.currentDocTypeId);
        formData.append('file', this.newDocument.file);

        const response = await axios.post('/api/user-docs', formData);
        const createdDocument = response.data && (
          response.data.document ||
          (response.data.content && response.data.content.document)
        );

        if (createdDocument) {
          if (this.currentDocType === 'idCredor') {
            this.files.idCredor = createdDocument;
          } else if (this.currentDocType === 'procuracao') {
            this.files.procuracao = createdDocument;
          }
        }

        await this.getDocuments(this.currentDocTypeId);
        this.closeAddModalDocument();

        this.$dialog.notify.success("Documento salvo com sucesso", { position: 'top-right', timeout: 5000 });
      } catch (error) {
        this.$dialog.notify.error("Erro ao salvar o documento", { position: 'top-right', timeout: 5000 });
      } finally {
        this.savingDocument = false;

      }
    },

  }
};
</script>


<style>
.custom-modal-title {
  font-size: 20px;

  @media (max-width: 600px) {
    font-size: 14px;
  }
}
</style>
